import breakpoints from '../css/breakpoints';
import createTransformSourcePhoton from '../../utils/photon';

/**
 * Configuration for responsive image sizes
 *
 * Should contain the following:
 * - createTransformSourcePhoton factory function. See 'src/utils/images/photon.js' for an example
 * - positions object containing configurations for each position in which an image could appear on the site.
 *    Each position config should contain:
 *    - sizes: an array of objects containing a `mediaQuery` and `value` to be use for constructing the `sizes` attribute
 *    - sources: an array of objects containing transformation properties to be used for generating the `srcset` attribute.
 *        NOTE: currently this must contain a `width` property in order to generate a descriptor for each souce in the `srcset`
 *    - any other arbitrary properties you need to use in the createTransformSourcePhoton function
 *
 * TODO: refactor to allow a `descriptor` property for use as a custom descriptor (you might want to use a density descriptor, for example, instead of a `w`)
 */
export default {
  full: {
    sizes: [],
    sources: [],
  },
  authorOverview: {
    sizes: [
      {
        mediaQuery: breakpoints.mdMin,
        value: '140px',
      },
      { value: '72px' },
    ],
    sources: [
      { width: 140, height: 140, isDefault: true },
      { width: 280, height: 280 },
      { width: 72, height: 72 },
      { width: 144, height: 144 },
    ],
  },
  authorHeader: {
    sizes: [
      {
        mediaQuery: breakpoints.smMin,
        value: '220px',
      },
      { value: '140px' },
    ],
    sources: [
      { width: 220, height: 220 },
      { width: 440, height: 440 },
      { width: 140, height: 140, isDefault: true },
      { width: 280, height: 280 },
    ],
  },
  featuredImage: {
    sizes: [
      {
        mediaQuery: breakpoints.lgMin,
        value: '830px',
      },
      {
        mediaQuery: breakpoints.smMin,
        value: '85vw',
      },
      { value: '100vw' },
    ],
    transform: 'resize',
    sources: [
      { width: 830, height: 467 },
      { width: 1200, height: 675 },
      { width: 640, height: 360, isDefault: true },
      { width: 960, height: 540 },
      { width: 511, height: 287 },
      { width: 766, height: 431 },
    ],
  },
  featuredImageFlexible: {
    sizes: [
      { value: '993px' },
    ],
    transform: 'none',
    quality: 100,
    sources: [
      { width: 993, isDefault: true },
    ],
  },
  linearListView: {
    transform: 'resize',
    sizes: [
      {
        mediaQuery: breakpoints.smMin,
        value: '223px',
      },
      { value: '80vw' },
    ],
    sources: [
      { width: 223, height: 125, isDefault: true },
      { width: 480, height: 270 },
      { width: 528, height: 297 },
      { width: 608, height: 342 },
      { width: 720, height: 405 },
    ],
  },
  twoUpListView: {
    transform: 'resize',
    sizes: [
      {
        mediaQuery: breakpoints.smMin,
        value: '45vw',
      },
      { value: '80vw' },
    ],
    sources: [
      { width: 608, height: 342 },
      { width: 1094, height: 615 },
      { width: 480, height: 270, isDefault: true },
      { width: 720, height: 405 },
      { width: 352, height: 198 },
      { width: 528, height: 297 },
    ],
  },
  threeUpListView: {
    transform: 'resize',
    sizes: [
      {
        mediaQuery: breakpoints.xlMin,
        value: '394px',
      },
      {
        mediaQuery: breakpoints.smMin,
        value: '30vw',
      },
      { value: '80vw' },
    ],
    sources: [
      { width: 480, height: 270, isDefault: true },
      { width: 720, height: 405 },
      { width: 394, height: 222 },
      { width: 608, height: 342 },
      { width: 310, height: 174 },
      { width: 528, height: 297 },
    ],
  },
  sample: {
    sizes: [
      {
        mediaQuery: breakpoints.lgMin,
        value: '1280px',
      },
      { value: '300px' },
    ],
    quality: 60,
    transform: 'resize',
    sources: [
      { width: 1280, height: 720, isDefault: true },
      { width: 300, height: 200 },
    ],
  },
};

export { createTransformSourcePhoton };
